export default __webpack_public_path__ + "static/media/1.e0bffbae.png";